import styled from 'styled-components';
import {Body1} from '../../ui/atoms/typography';

export const ResponsiveBody1 = styled(Body1)`
  text-align: right;
  margin-bottom: 100px;
  @media (max-width: 1023px) {
    text-align: center;
    margin-bottom: 16px;
  }
`;

export const ResponsiveWorkspaceLogo = styled.span`
  display: inline-block;
  width: 100%;
  text-align: center;
`;

export const NotificationWrapper = styled.div`
  position: fixed;
  top: 0;
  width: 100%;
`;
